var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-entity-dialog',{ref:"base",attrs:{"collection":"programs","title":_vm.$t('programs.share_program'),"shared-toast":_vm.$t('programs.shared')}})
}
var staticRenderFns = []

export { render, staticRenderFns }